import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from "../../../../icons";
import cn from "../../../../utils/cn";
import Typography from "../../../Typography";
const DropdownBodyPlaceholder = ({ text, icon, className }) => (_jsxs("div", { className: cn("flex h-52 flex-col items-center justify-center px-auto", className), children: [icon ? _jsx(Icon, { name: icon }) : _jsx(Icon, { name: "cb-placeholder-checklists", className: "mb-2" }), _jsx(Typography, { variant: "body", color: "secondary", children: text || "Não existe dados." })] }));
export default DropdownBodyPlaceholder;
